import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackTelemetryFromDobbyBackend } from "@shared/utils/telemetryApi";

/**
 * Hook to log page views and URL changes to telemetry.
 * Tracks both initial page load and subsequent navigation.
 */
export function useLogPageLoad() {
  const location = useLocation();

  useEffect(() => {
    trackTelemetryFromDobbyBackend({
      name: "page_view",
      extra: {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
      },
    });
  }, [location.pathname, location.search, location.hash]);
}
